import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import api from "../../../helper/api";
import { toast } from "react-toastify";

export const listFunctions = createAsyncThunk("user/listFunctions", async (payload) => {

  const response = await api.post("admin/functions/list", payload);
 
  return response.data;
});

const listFunctionsSlice = createSlice({
  name: "user",
  initialState: {
    data:null,
    loading: false,
    error: null,
  },
  middleware: (getDefaultMiddleware) =>
  getDefaultMiddleware({
    serializableCheck: {
      ignoredPaths: ["payload.headers"],
    },
  }),
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(listFunctions.pending, (state) => {
        state.loading = true;
      })
      .addCase(listFunctions.fulfilled, (state, action) => {
   
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(listFunctions.rejected, (state, action) => {
        state.loading = false;
     
        toast.error(action.error.message);
      });
  },
});

export default listFunctionsSlice.reducer;
